import React, { useState, useRef, useEffect } from 'react';

function TeacherSelect({ teachers, value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const wrapperRef = useRef(null);

  const selectedTeacher = teachers.find(t => t.guid === value);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredTeachers = teachers.filter(teacher =>
    teacher.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (teacher) => {
    onChange(teacher.guid);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="custom-select" ref={wrapperRef}>
      <input
        type="text"
        className="custom-select-input"
        value={selectedTeacher ? selectedTeacher.name : ''}
        placeholder="Выберите преподавателя"
        readOnly
        onClick={() => setIsOpen(!isOpen)}
      />
      {isOpen && (
        <div className="custom-select-dropdown active">
          <div className="custom-select-search">
            <input
              type="text"
              placeholder="Поиск по ФИО"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div className="custom-select-options">
            {filteredTeachers.map((teacher) => (
              <div
                key={teacher.guid}
                className={`custom-select-option ${value === teacher.guid ? 'selected' : ''}`}
                onClick={() => handleSelect(teacher)}
              >
                {teacher.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default TeacherSelect;







